import CustomApiError from './CustomApiError'

export default class OccurrenceError extends CustomApiError {
  toDictionary () {
    return {
      'ALREADY_COMPLETED': 'Ocorrência já finalizada.',
      'OCCURRENCE_NOT_FOUND': 'Ocorrência não encontrada.'
    }
  }
}
